// src/ui/consent.ts
// Minimal cookie consent banner for Clarity gating. Required in EU.

import type { Consent } from '../types';

export function renderConsentBanner(onDecide: (accept: boolean) => void): HTMLElement {
  const el = document.createElement('div');
  el.className = 'consent-banner';
  el.innerHTML = `
    <span>Cookies for anonymous session insights. Your game works either way.</span>
    <button class="accept">Accept</button>
    <button class="reject">Reject</button>
  `;
  const accept = () => { cleanup(); onDecide(true); };
  const reject = () => { cleanup(); onDecide(false); };
  el.querySelector('.accept')!.addEventListener('click', accept);
  el.querySelector('.reject')!.addEventListener('click', reject);
  function cleanup() {
    el.remove();
  }
  return el;
}

export function makeConsent(accept: boolean, todayIso: string): Consent {
  return { analytics: accept, decidedAt: todayIso };
}
